import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { CommonDataService } from '../../project/services/commonData.service';
import { Enums } from '../../shared/models/enums';
import { ModalService } from '../../shared/services/modal.service';
import { ParentChildCommunicationService } from '../../shared/services/parent-child-communication.service';
import { ToastService } from '../../shared/services/toast.service';
import { ModalConfirmationComponent } from '../../shared/widgets';
import { PrometricService } from '../services/prometric.service';

@Injectable()
export class PrometricCommonService {

    applicants: any[];    
    applicantData: any[];
    staticText: any;
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    isSendtoPrometricClicked: boolean;
    disableSendtoPrometric: boolean = true;
    
    totalRecords: Number;
    subscription: Subscription;
    

    constructor(
        private prometricService: PrometricService,
        public userPersistenceService: UserPersistenceService,
        private modalService: ModalService,
        private commonDataService: CommonDataService,
        private toastService: ToastService,
        private parentChildCommunicationService: ParentChildCommunicationService        
    ) { }     

    sendCandidatestoPrometric(selectedApplicants: any[]) {
        const modalOptions = {
            class: 'modal-centre-screen',
            ignoreBackdropClick: true,
            keyboard: false,
            data: {
                heading: this.userPersistenceService.generalTranslation.Confirmation,
                content: `Do you want to send applicant` + (selectedApplicants.length > 1 ? `(s)` : ``) + ` data to Prometric?`,
                okButton: this.userPersistenceService.generalTranslation.PopupYes,
                cancelButton: this.userPersistenceService.generalTranslation.PopupNo
            }
        };

        this.modalRef = this.modalService.openModal(ModalConfirmationComponent, modalOptions);

        this.modalRef.content.action.subscribe((result: any) => {
            if (result.status === this.confirmationStatus.ok) {
                this.sendCandidatesToPrometric(selectedApplicants);
            }
        });
    }

    sendCandidatesToPrometric(selectedRows) {        
        this.prometricService.sendCandidatestoPrometric(selectedRows).subscribe((data: any) => {
            let successMessage = data.filter(x => x.key == 'Success');
            let errMessage = data.filter(x => x.key == 'Error');
            if (!this.commonDataService.isUndefinedOrNull(successMessage) && successMessage.length > 0) {
                this.toastService.success(successMessage[0].value);
                this.parentChildCommunicationService.publish('onEligibilityGenerate', { isGenerated: true });
            }
            else if (!this.commonDataService.isUndefinedOrNull(errMessage) && errMessage.length > 0) {                
                this.parentChildCommunicationService
                    .publish('onEligibilityGenerate', { isGenerated: false, errorMessage: errMessage[0].value, prometricError: data });
            }            
        }, (error) => {
            this.toastService.error(this.userPersistenceService.generalTranslation.ErrorMsg);
        });       
    }
}
